import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import React from 'react';

import { CommonStyles } from '~common/react/CommonStyles';
import { getLinkMarkup, ILink } from '~src/spacesPlatform/components/ListView/dataGridCells/LinkCell';
import { StyledCellFormatter } from '~src/spacesPlatform/components/ListView/StyledCellWrapper';

import { DataGridProfilePicture } from '../../../../app/content/DataGridProfilePicture';
import { ProfilePictureStyles } from '../../../../app/content/styles/ProfilePictureStyles';
import { SiteRolesHelper } from '../../../../siteManagement/helpers/SiteRolesHelper';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IGroupInfo } from '../../../../ts/models/IGroupInfo';
import { GrantLicenseModes } from '../../../../ts/ServerApi/requests/SyncActiveDirectoryGroupRequest';

export namespace GroupDataGridCells {

  export function ProfilePictureCell(
      getProfileProps: (row: DataGrid.Row) => DataGridProfilePicture.Props,
      getLinkOptions: (row: DataGrid.Row) => ILink
    ): React.StatelessComponent<BodyCell.Props> {
    return StyledCellFormatter(function ProfilePictureCells(props: BodyCell.Props) {
      const linkOptions = getLinkOptions(props.row);
      return (
        <div style={ProfilePictureStyles.Layout.GroupNameWithProfilePictureCellWrapperStyle}>
          <span style={ProfilePictureStyles.Layout.GroupNameWithProfilePictureCellChildStyle}>
            <DataGridProfilePicture {...getProfileProps(props.row)} />
          </span>
          <span style={ProfilePictureStyles.Layout.GroupNameWithProfilePictureCellChildDisplayNameStyle}>
            <span data-tb-test-id={linkOptions.testId} style={CommonStyles.Layout.FlexBlockLeftAndCenter}>
              {getLinkMarkup(linkOptions, props.row)}
            </span>
          </span>
        </div>
      );
    });
  }

  export function MinimumSiteRoleCell(): React.StatelessComponent<BodyCell.Props> {
    return StyledCellFormatter(function generateSiteRoleName(props: BodyCell.Props) {
      const group = props.row.data as IGroupInfo;
      let siteRole: string = group.minimumSiteRole ? SiteRolesHelper.siteRoleToName(group.minimumSiteRole) : '';
      if (FeatureFlags.licenseUponLoginEnabled && group
          && (group.grantLicenseMode === undefined || group.grantLicenseMode !== GrantLicenseModes.ON_LOGIN)
          && (group.domainName === undefined || group.domainName === 'local')) {
          siteRole = '';
      }
      return (
        <div>{siteRole}</div>
      );
    });
  }
}
